
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ValidationError from '~/components/ValidationError.vue'
import { BuildingManagementContactForm } from '~/lib/contact/ContactForms'

@Component({
  components: { ValidationError, ValidationProvider, ValidationObserver }
})
export default class BuildingManagementProgram extends Vue {
  @Prop({ default: false })
  readonly sendingError: boolean = false

  @Prop({ default: false })
  readonly sent: boolean = false

  @Prop({ default: false })
  readonly sending: boolean = false

  form: BuildingManagementContactForm = {
    name: '',
    phone: '',
    size: '',
    address: '',
    email: '',
    buildingName: ''
  }

  @Emit()
  submit(): BuildingManagementContactForm {
    return this.form
  }
}
